import React, { useContext, useEffect, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { AvatarName } from '../UiKit/AvatarName';
import { EditName } from '../UiKit/EditName';
import { PopoverH } from '../UiKit/TooltipH';
import { Popover } from 'antd';
import { Preloader } from '../UiKit/kit';
import { Icon } from '../UiKit/Icon';
import { Button } from '../UiKit/Button';

export function PentaName({
  penta = {},
  icon = '',
  children,
  flat = false,
  className = 'x_calc_result_title ellipsis',
}) {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  const $ui = context.$ui;

  const [pentaInner, setPentaInner] = useState(penta)

  useEffect(() => {
    if (
      penta.token !== pentaInner.token
      || penta.members.length !== pentaInner.members.length
      || penta.name !== pentaInner.name
    ) {
      setPentaInner(penta)
    }
  }, [penta])


  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleUpdateName = (newName) => {
    hide();
    handleOpenChange(false);
    context.x.updatePenta({
      'token': penta.token,
      'name': newName
    }, (newPenta) => setPentaInner(prev => ({ ...prev, ...newPenta })))
  };

  const editNamePopover = (
    <EditName
      name={pentaInner.name}
      placement='bottom'
      handleUpdate={handleUpdateName}
    />
  );

  const nameTriggerClassName = [
    `x_penta_name_trigger ${className}`,
    children ? 'x_penta_name_trigger' : '',
  ].filter(Boolean).join(' ');

  const nameTriggerStyle = children
    ? { display: 'flex', minWidth: 0 }
    : { display: 'block', minWidth: 0 };

  // const nameTriggerStyle = { display: 'block', minWidth: 0 };


  return (
    <>


      {children && <PopoverH
        fresh={true}
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
        title={editNamePopover}
      >
        <div className={nameTriggerClassName} style={nameTriggerStyle}>
          {!(context.updatingPenta && context.updatingPenta === pentaInner.token) && <>
              <PentaNameText penta={pentaInner} flat={false} />
              {children}
            {/* {icon && <Button sm icon={icon}></Button>} */}
          </>}
          {context.updatingPenta && context.updatingPenta === pentaInner.token && <Preloader width={16} height={16} />}
        </div>
      </PopoverH>}

      {/* <Popover
        content={<a onClick={hide}>Close</a>}
        // title="Title"
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
      >
        <Button type="primary">Click me</Button>
      </Popover> */}

      {!children && <PopoverH
        open={open}
        onOpenChange={handleOpenChange}
        trigger="click"
        title={editNamePopover}
      >
        <div className={nameTriggerClassName} style={nameTriggerStyle}>
          {/* <div className="_f _fgap04 _fm"> */}
            <span>
            <PentaNameText penta={pentaInner} flat={flat} />
            </span>

        </div>
            <div className="x_penta_name_icon">
              {icon && <Button ghost sm icon={icon}></Button>}
            </div>
      </PopoverH>}


    </>
  )
}



export const PentaNameText = ({ penta, flat = true }) => {
  return (<>

    {/* {!penta.name && !flat && penta.members && penta.members.map((one, index, arr) => {
      return <span key={`name_${one.avatar.token}`}><span className="x_penta_name_1">{getName(one)}</span> {index < arr.length - 1 ? <span className="x_penta_name_and">& </span> : ''} {arr.length === 1 && <><span className="x_penta_name_and">& </span>...</>}</span>;
    })} */}
    {/* {!penta.name && flat && penta.members && penta.members.map((one, index, arr) => {
        return <React.Fragment key={`name_${one.avatar.token}`}><React.Fragment>{one.avatar.name ? one.avatar.name : context.getDefaultTitle(one.avatar.design)}</React.Fragment> {index < arr.length - 1 ? <React.Fragment>& </React.Fragment > : ''}</React.Fragment >;
      })} */}

    {!penta.name && !flat && penta.members && penta.members.map((one, index, arr) => {
      return <span key={`name_${one.avatar.token}`} style={{ maxWidth: `calc(100% / ${arr.length})`}}>
        <AvatarName  avatar={one.avatar} /> {index < arr.length - 1 ? <span className="x_penta_name_and">& </span> : ''} {arr.length === 1 && <><span className="x_penta_name_and">& </span>...</>}</span>;
    })}

    {!penta.name && flat && penta.members && penta.members.map((one, index, arr) => {
      return <React.Fragment key={`name_${one.avatar.token}`}>
        <React.Fragment>
          <AvatarName avatar={one.avatar} style={{ maxWidth: `calc(100% / ${arr.length})` }}/>
        </React.Fragment>
        {index < arr.length - 1 ? <React.Fragment>& </React.Fragment > : ''}
      </React.Fragment >;
    })}

    {penta.name}

  </>)
}
